const styles = {
  adornment: {
    mr: 1,
  },
} as const;

export default styles;
